import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GoogleLogoSvg from '../../utility/Svg/GoogleLogoSvg';

const styles = {
    root: {
        background: '#002394',
        display: 'flex',
        height: '64px',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
        alignSelf: 'stretch',
        padding: '0 16px',
        borderRadius: '8px 8px 0 0!improt`ant',
    },
    left: { display: 'flex', alignItems: 'center', gap: '12px' },
    title: {
        color: '#FFF',
        fontFamily: 'Roboto',
        fontSize: '20px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '32px',
        letterSpacing: '0.15px',
        fontFeatureSettings: "'liga' off, 'clig' off",
    },
    closeBtn: { color: '#FFF', p: 0, width: '35px', height: '35px' },
};

const ModalHeader = ({ onClose }) => {
    return (
        <div style={styles.root}>
            {/* <Box sx={styles.left}> */}
            <Typography sx={styles.title}>New Review Request</Typography>
            {/* </Box> */}

            <IconButton onClick={onClose} size="small" sx={styles.closeBtn}>
                <CloseIcon />
            </IconButton>
        </div>
    );
};

export default ModalHeader;
